export function useFolderHelper() {
    return {
        getIcon,
    };
}

export type FolderIconData = {
    edcType: number;
    ssType: string;
    hasCnOrWk: boolean;
    hasQualif: boolean;
};

const EDC_TYPE = {
    WIP: 1,
    SH: 2,
    PUB: 3,
} as const;

const AO_TYPE = {
    SAS_AO: 'SAS_AO',
    AO: 'AO',
    AO_OFFER: 'AO_OFFRE',
    AO_RESPONSES: 'AO_REPONSES',
    AO_RESPONSE_USER: 'AO_REPONSE_USER',
} as const;

const BIM_TYPE = {
    SAS: 'SAS',
    VALID_FOLDER: 'DOSSIER_VALID',
    REJECTED_FOLDER: 'DOSSIER_REFUS',
} as const;

const ICON_MAP_EDC: Record<number, string> = {
    [EDC_TYPE.WIP]: 'ax ax-folder-edc-pending',
    [EDC_TYPE.SH]: 'ax ax-folder-edc-shared',
    [EDC_TYPE.PUB]: 'ax ax-folder-edc-published',
};

const ICON_MAP_SS: Record<string, string> = {
    [AO_TYPE.SAS_AO]: 'ax ax-folder-ao',
    [AO_TYPE.AO]: 'ax ax-folder-ao-pending',
    [AO_TYPE.AO_OFFER]: 'ax ax-folder-ao-offer',
    [AO_TYPE.AO_RESPONSES]: 'ax ax-folder-ao-reponses',
    [AO_TYPE.AO_RESPONSE_USER]: 'ax ax-folder-ao-response',

    [BIM_TYPE.SAS]: 'ax ax-sas-bim',
    [BIM_TYPE.VALID_FOLDER]: 'ax ax-sas-bim-ok',
    [BIM_TYPE.REJECTED_FOLDER]: 'ax ax-sas-bim-ref',
};

const getIcon = (folder: FolderIconData) => {
    if (ICON_MAP_EDC[folder.edcType]) {
        return ICON_MAP_EDC[folder.edcType];
    }

    if (ICON_MAP_SS[folder.ssType]) {
        return 'ax ax-folder-color';
    }

    if (folder.hasCnOrWk || folder.hasQualif) {
        return 'ax ax-folder-settings-1';
    }

    return 'ax ax-folder-color';
};
